import AppointmentContainer from "./TwoFANotEnabled.container";

export default AppointmentContainer;
